/* eslint-disable react/jsx-one-expression-per-line */
import { ConfigProvider, Form, Slider } from 'antd';
import React, { memo } from 'react';

import { FilterComponentInput } from '@core/offices/types';

const component = (props: FilterComponentInput) => {
  return (
    <Form.Item label={props.filter.label}>
      <ConfigProvider
        theme={{
          components: {
            Slider: {
              handleColor: 'var(--secondary)',
              handleActiveColor: 'var(--secondary)',
              handleSizeHover: 10,
              colorLink: 'var(--secondary)',
            },
          },
        }}
      >
        <Slider
          styles={{
            track: {
              backgroundColor: 'var(--secondary)',
            },
          }}
          range
          min={props.filter.minValue}
          max={props.filter.maxValue || 1000000}
          defaultValue={[20, 50]}
          onChange={(numbers) => props.handleChange(numbers)}
        />
        <div className="flex justify-between items-start">
          <span>
            {props.filter.minValue} {props.filter.fieldName === 'price' && '$'}
          </span>
          <span>
            {props.filter.maxValue} {props.filter.fieldName === 'price' && '$'}
          </span>
        </div>
      </ConfigProvider>
    </Form.Item>
  );
};
export default memo(component);
